import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import * as aa from "../../generated/UserAPIAgent";
import { URL_PATHS } from "../../routes";

interface RegisterBasicRouteProps extends RouteProps {
    user: aa.User | null;
    shouldRegister: boolean;
    children: JSX.Element;
}

const RegisterPaidRoute = (props: RegisterBasicRouteProps) => {
    const { children, shouldRegister, ...rest } = props;
    return (
        <Route
            {...rest}
            render={({ location }) =>
                shouldRegister ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: URL_PATHS.signup(),
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
};

export default RegisterPaidRoute;
